/**
 * @file goToPoints/index.js
 * @description Go To Points page — tracks feature analytic once per session
 */
import { useEffect, useLayoutEffect, useState } from "react";
import DesktopGTP from "./viewport/desktop";
import MobileGTP from "./viewport/mobile";
import Navigation from "../../components/navigation";
import { useHistory } from "react-router-dom";
import { changeLanguage } from "../../language/i18n";
import { PostFeatureAnalytic } from "../../api/gtpAPI";

const GTP_ANALYTIC_SESSION_KEY = "gtp_analytic_tracked";

const GoToPoints = () => {
  const history = useHistory();
  const [viewport, setViewport] = useState(null);

  const [isLanding, setLanding] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem(GTP_ANALYTIC_SESSION_KEY)) {
      PostFeatureAnalytic({ feature: "GO_TO_POINTS_WEB" })
        .then(() => sessionStorage.setItem(GTP_ANALYTIC_SESSION_KEY, "1"))
        .catch(() => {});
    }
  }, []);

  useLayoutEffect(() => {
    const updateSize = setViewport(
      window.innerWidth >= 576 ? "desktop" : "mobile",
    );

    window.addEventListener("resize", updateSize);

    if (
      window.location.pathname
        .split("/")
        .filter((el, i, arr) => i === arr.length - 1)[0] === "landing"
    )
      setLanding(true);
    else setLanding(false);

    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <>
      {viewport === "desktop" ? (
        <>
          {isLanding && <Navigation />}
          <DesktopGTP isLanding={isLanding} />
        </>
      ) : viewport === "mobile" ? (
        <MobileGTP />
      ) : null}
    </>
  );
};

export default GoToPoints;
